// extracted by mini-css-extract-plugin
export default {"area":"Register_area__vY9zf","form":"Register_form__klon-","button":"Register_button__WCvTv","logo":"Register_logo__-hWfS","createAccount":"Register_createAccount__X5ylD"};